import React from "react";
// mui5
import Button from "@mui/material/Button";
// custom context
import { useCart } from "../../context/CartContext";
// custom component
import QuantityControl from "./QuantityControl";
import {
  StyledCardActions,
  StyledCardContainer,
  StyledCardContent,
  StyledCardHeader,
  StyledCardMedia,
} from "./styledComponents";

function PokemonCardCart({ pokemon }) {
  const { onRemoveItemFromCart } = useCart();
  return (
    <StyledCardContainer>
      <StyledCardMedia
        component="img"
        image={pokemon.image}
        alt={pokemon.name}
      />
      <StyledCardContent>
        <StyledCardHeader
          title={pokemon.name}
          subheader={`$${pokemon.price}`}
        />
        <StyledCardActions>
          <QuantityControl pokemon={pokemon} />

          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => onRemoveItemFromCart(pokemon)}
            // sx={{color: "#eee"}}
          >
            Remove
          </Button>
        </StyledCardActions>
      </StyledCardContent>
    </StyledCardContainer>
  );
}

export default PokemonCardCart;
